import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=2b39a96d"
import script from "./Supplies.vue?vue&type=script&lang=js"
export * from "./Supplies.vue?vue&type=script&lang=js"
import style0 from "./Supplies.vue?vue&type=style&index=0&id=2b39a96d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports